import HttpResponse from "../../../../../utils/http/http.response";

export enum TaxiCorporationPlanEntryBillingsResponseBillingModel {
  AB = "AB",
  ABA = "ABA",
  OTHER = "OTHER",
  SABS = "SABS",
}

export type TaxiCorporationPlanEntryBillingsResponseDataItem = {
  id: string;
  date: string;
  humanId: number;
  distance: number;
  favorableDistance: number;
  rateForDistance: number;
  baseDistanceRate: number;
  billingModel: TaxiCorporationPlanEntryBillingsResponseBillingModel;
  fleetPartner: string | null;
  driver: string;
  route: string[];
  cargoOrderHumanIds: number[];
  amountForDistance: number | null;
  amountForChargeHaltings: number | null;
  amountForChargeHighways: number | null;
  sumOfBonuses: number | null;
  sumOfPenalties: number | null;
  allContributionsAmount: number | null;
};

export type TaxiCorporationPlanEntryBillingsResponseDataStats = {
  distance: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  allContributionsAmount: number;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

export type TaxiCorporationPlanEntryBillingsResponseData = {
  data: TaxiCorporationPlanEntryBillingsResponseDataItem[];
  stats: TaxiCorporationPlanEntryBillingsResponseDataStats;
  totalCount: number;
};

type TaxiCorporationPlanEntryBillingsResponse =
  HttpResponse<TaxiCorporationPlanEntryBillingsResponseData>;

export default TaxiCorporationPlanEntryBillingsResponse;
